import React, { useState } from "react";
import type { TriggerKey, RefreshTriggers } from "../../models/ArtworkDataTriggers";
import { ArtworkReference, ArtworkReferenceType } from "../../models/ArtworkReference";
import ArtworkReferenceManager from "./ArtworkReferenceManager";
import { Box, Paper, Typography, Tooltip, Divider } from '@mui/material';
import './ArtReferenceStyleSheet.css';

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../styles/mui_theme";

interface Props {
    artworkId: number;
    refresh: RefreshTriggers;
}

const ArtworkReferencesTabs: React.FC<Props> = ({ artworkId, refresh }) => {
    type selectOption = {
        label: string;
        value: ArtworkReferenceType;
        description: string;
        icon: string;
    }

    const options: selectOption[] =
        [
            { label: 'Literature', value: 'Literature', description: 'View, edit or add a literature reference', icon: '📖' },
            { label: 'Exhibition', value: 'Exhibit', description: 'View, edit or add an exhibition reference', icon: '🎨' }
        ];

    const [selected, setSelected] = useState<ArtworkReferenceType>(options[0].value);

    const handleSelect = (value: string) => {
        if (value == "Literature") { setSelected("Literature") } else { setSelected("Exhibit") };
    };

    return (
        <ThemeProvider theme={theme}>
            <Paper elevation={3} square={false} sx={{ p: 2, width: '100%', boxSizing: 'border-box' }}>
                <div className="section-header">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Artwork References</Typography>
                    </Box>
                </div>
            <Divider sx={{ my: 2 }} />
                {/* Options group*/}
                <div className="enhanced-radio-group">
                {options.map((option) => (
                    <Tooltip title={option.description}>
                        <label
                            key={option.value}
                            className={`enhanced-radio-label ${selected === option.value ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                value={option.value}
                                checked={selected === option.value}
                                onChange={(e) => handleSelect(e.target.value)}
                            />
                            <div className="radio-content">
                                <div className="radio-title">{option.label}</div>
                            </div>
                            {option.icon && (
                                <div className="radio-icon">{option.icon}</div>
                            )}
                        </label>
                    </Tooltip>
                    ))}
                </div>
            <Divider sx={{ my: 2 }} />
            {/* Manager for selected type */}
                <ArtworkReferenceManager artworkId={artworkId} type={selected} refresh={refresh} />
            </Paper>
        </ThemeProvider>
    );
}

export default ArtworkReferencesTabs;